import styled from "styled-components";
import tw from "twin.macro";

const SidebarStyles = styled.nav.attrs({
  className: "side-nav",
})`
  z-index: 50;
`;
export default SidebarStyles;
